<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'

defineProps<{
  active?: boolean
  label: string
  icon?: IconDefinition
  iconColor?: string
  iconBgColor?: string
  image?: string
  imageAlt?: string
  url?: string
  badge?: string
}>()
</script>

<template>
  <GLink
    class="
      group w-full flex gap-2 items-center
      rounded-v2md
      font-medium text-navy hover:bg-surface-blue
      text-lg lg:text-sm !leading-none
      px-6 py-3 lg:px-1 lg:py-1
    "
    :href="url"
  >
    <div
      class="rounded-v2sm lg:rounded-v2xs p-1.5 lg:p-1 flex items-center justify-center"
      :style="{
        backgroundColor: iconBgColor ?? '#F2F1F1',
        color: iconColor ?? '#BDBDBD',
      }"
    >
      <GIcon
        v-if="icon"
        :icon="icon"
        class="!g-icon-md !lg:g-icon-sm"
      />
      <img
        v-else-if="image"
        :src="image"
        :alt="imageAlt || 'Menu item image'"
        class="w-5 md:w-4 object-contain"
      >
    </div>
    <div class="h-full flex items-center gap-2">
      {{ label }}
      <span
        v-if="badge"
        class="
          bg-primary-base text-white text-xs font-medium rounded-full px-2 h-4
          inline-flex items-center justify-center leading-none
        "
      >
        {{ badge }}
      </span>
    </div>
  </GLink>
</template>
